import { Avatar as AvatarComponent, Image } from '@mantine/core'

import grayface from '../../assets/images/grayface.svg'

export const Avatar = AvatarComponent.extend({
  defaultProps: {
    children: <Image src={grayface} />,
  },
})
